import { metricTrendFragment } from './fragments/reports';

export const inventoryValueMetricsQuery = `
  query InventoryValueMetrics(
    $reportFilter: ReportFilterArgs!
  ) {
    results: inventoryValueMetrics(reportFilter: $reportFilter) {
      ${metricTrendFragment}
    }
  }
`;

export const inventoryDemandIndexMetricsQuery = `
  query InventoryDemandIndexMetrics(
    $reportFilter: ReportFilterArgs!
  ) {
    results: inventoryDemandIndexMetrics(reportFilter: $reportFilter) {
      ${metricTrendFragment}
    }
  }
`;

export const inventoryEngagedMetricsQuery = `
  query InventoryEngagedMetrics(
    $reportFilter: ReportFilterArgs!
  ) {
    results: inventoryEngagedMetrics(reportFilter: $reportFilter) {
      ${metricTrendFragment}
    }
  }
`;

export const getReservationRateMetricsQuery = `
  query ReservationRateMetrics(
    $reportFilter: ReportFilterArgs!
  ) {
    metrics: reservationRateMetrics(reportFilter: $reportFilter) {
      ${metricTrendFragment}
    }
  }
`;

export const reservationMetricsQuery = `
  query ReservationMetrics(
    $reportFilter: ReportFilterArgs!
  ) {
    results: reservationMetrics(reportFilter: $reportFilter) {
      ${metricTrendFragment}
    }
  }
`;

export const inventoryEngagementQuery = `
  query InventoryEngagement(
    $reportFilter: ReportFilterArgs!
  ) {
    results: inventoryEngagement(reportFilter: $reportFilter) {
      engagedInventoryCount
      unengagedInventoryCount
      unengagedInventoryValue
    }
  }
`;

export const getInventoryVsBuyerInterestByPriceBandQuery = `
  query InventoryVsBuyerInterestByPriceBand(
    $reportFilter: ReportFilterArgs!
  ) {
    results: inventoryVsBuyerInterestByPriceBand(reportFilter: $reportFilter) {
      priceBandKey
      availableInventoryCount
      engagedVisitorsCount
    }
  }
`;

export const getDemandByCommunityProjectQuery = `
  query DemandByCommunityProject(
    $reportFilter: ReportFilterArgs!
  ) {
    items: demandByCommunityProject(reportFilter: $reportFilter) {
      id
      name
      entityType
      availableCount
      buyersCount
      reservationsCount
      demandIndex
      reservationRate
    }
  }
`;

export const getDemandByModelQuery = `
  query DemandByModel(
    $reportFilter: ReportFilterArgs!
  ) {
    items: demandByModel(reportFilter: $reportFilter) {
      id
      name
      entityType
      availableCount
      buyersCount
      demandIndex
    }
  }
`;

export const getNewInventoryMetricsQuery = `
  query NewInventoryMetrics(
    $reportFilter: ReportFilterArgs!
  ) {
    metrics: newInventoryMetrics(reportFilter: $reportFilter) {
      ${metricTrendFragment}
    }
  }
`;

export const getSoldInventoryMetricsQuery = `
  query SoldInventoryMetrics(
    $reportFilter: ReportFilterArgs!
  ) {
    metrics: soldInventoryMetrics(reportFilter: $reportFilter) {
      ${metricTrendFragment}
    }
  }
`;

export const getReservedInventoryMetricsQuery = `
  query ReservedInventoryMetrics(
    $reportFilter: ReportFilterArgs!
  ) {
    metrics: reservedInventoryMetrics(reportFilter: $reportFilter) {
      ${metricTrendFragment}
    }
  }
`;

export const getAvgInventoryValueMetricsQuery = `
  query AvgInventoryValueMetrics(
    $reportFilter: ReportFilterArgs!
  ) {
    metrics: avgInventoryValueMetrics(reportFilter: $reportFilter) {
      ${metricTrendFragment}
    }
  }
`;

export const getAvgDaysOnMarketMetricsQuery = `
  query AvgDaysOnMarketMetrics(
    $reportFilter: ReportFilterArgs!
  ) {
    metrics: avgDaysOnMarketMetrics(reportFilter: $reportFilter) {
      ${metricTrendFragment}
    }
  }
`;

export const getDemandIndexOverTimeQuery = `
  query InventoryDemandIndexOverTime(
    $reportFilter: ReportFilterArgs!
    $interval: String
  ) {
    items: inventoryDemandIndexOverTime(reportFilter: $reportFilter, interval: $interval) {
      date
      availableInventoryCount
      engagedBuyersCount
    }
  }
`;

export const getTotalPublishedListingsMetricsQuery = `
  query TotalPublishedListingsMetrics(
    $reportFilter: ReportFilterArgs!
  ) {
    results: totalPublishedListingsMetrics(reportFilter: $reportFilter) {
      ${metricTrendFragment}
    }
  }
`;
